import { AxiosResponse } from 'axios';
import { Circle } from '../../models/circle';
import api from '../../services/api';

export interface AddCircleRequest {
	type: string;
	name: string;
	interests: string[];
}

export interface UpdateCircleRequest {
	circleId: string;
	type?: string;
	name?: string;
	interests?: string[];
}

export const addCircle = async (body: AddCircleRequest) => {
	return await api.post<Circle>(`/api/circle`, body).then(res => res.data);
};

export const updateCircle = async (body: UpdateCircleRequest) => {
	return await api.put<Circle>(`/api/circle/${body.circleId}`, body).then(res => res.data);
};

export const deleteCircle = async (circleId: string) => {
	await api.delete(`/api/Circle/${circleId}`, {});
};

export interface ParticipantsRequest {
	circleId: string;
	contacts: ContactRequest[];
}
export interface RemoveParticipantRequest {
	circleId: string;
	participantId: string;
}

export interface ContactRequest {
	countryCode: number;
	phoneNumber: string;
}
export const addParticipants = async ({ circleId, contacts }: ParticipantsRequest) => {
	if (circleId) {
		const res: AxiosResponse<null> = await api.post(`/api/circle/${circleId}/participant`, contacts);
		return res.data;
	}
};

export const removeParticipants = async ({ circleId, participantId }: RemoveParticipantRequest) => {
	if (circleId) {
		await api.delete(`/api/circle/${circleId}/participant/${participantId}`);
	}
};
